import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import ContactInformationService from '../../cornucopia/contact-us/contact-information-service';

class ContactData extends Component {
  static propTypes = {
    userType: PropTypes.string.isRequired,
    userCountry: PropTypes.string.isRequired
  };

  _getContactData = () => {
    let contactData;

    switch (this.props.userType) {
      case 'tenant':
        contactData = ContactInformationService.getTenantContactDataByCity(
          this.props.userCountry
        );
        break;
      case 'landlord':
        contactData = ContactInformationService.getLandlordContactDataByCity(
          this.props.userCountry
        );
        break;
      case 'partnerships':
        contactData = ContactInformationService.getPartnershipContactData();
        break;
      default:
        contactData = ContactInformationService.getOtherContactData();
    }

    return contactData;
  };

  _renderContactData = () => {
    const data = this._getContactData();
    return (
      <div className="contact-us__data grid__col grid__col--3-of-5 grid__col--centered">
        <p className="contact-us__data-telephone">{data.telephone}</p>
        <p>{trans(data.schedule)}</p>
        <p>{data.email}</p>
      </div>
    );
  };

  render() {
    return <div>{this._renderContactData()}</div>;
  }
}

export default ContactData;
